(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["downloads"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('download-chooser')) return;
    class DownloadChooser extends HTMLElement {
      connectedCallback() {
        this.options = [...this.querySelectorAll('[data-os]')];
        this.link = this.querySelector('[data-download]');
        this.options.forEach((o) => o.addEventListener('click', () => this.select(o.dataset.os)));
        const ua = navigator.userAgentData?.platform || navigator.platform || '';
        if (/mac/i.test(ua) && !/iphone|ipad/i.test(navigator.userAgent)) this.select('mac');
      }
      select(os) {
        const opt = this.options.find((o) => o.dataset.os === os);
        if (!opt) return;
        this.options.forEach((o) => o.setAttribute('aria-pressed', String(o === opt)));
        const version = this.querySelector('[data-version]');
        if (version && opt.dataset.version) version.lastChild.textContent = opt.dataset.version;
        if (this.link && opt.dataset.url) {
          this.link.href = opt.dataset.url;
          this.link.querySelector('[data-download-label]').textContent = `${this.link.dataset.prefix} ${opt.dataset.label}`;
        }
      }
    }
    customElements.define('download-chooser', DownloadChooser);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mk-hotspots')) return;

    class MkHotspots extends HTMLElement {
      connectedCallback() {
        this.spots = [...this.querySelectorAll('.hotspot')];
        this.spots.forEach((spot) => {
          spot.querySelector('.hotspot__dot').addEventListener('click', (e) => {
            e.stopPropagation();
            spot.classList.contains('is-open') ? this.close(spot) : this.open(spot);
          });
        });
        this.onDocClick = (e) => { if (!this.contains(e.target)) this.closeAll(); };
        document.addEventListener('click', this.onDocClick);
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            const open = this.querySelector('.hotspot.is-open');
            if (open) { this.close(open); open.querySelector('.hotspot__dot').focus(); }
          }
        });
        this.addEventListener('shopify:block:select', (e) => {
          const spot = e.target.closest('.hotspot');
          if (spot) this.open(spot);
        });
      }

      disconnectedCallback() { document.removeEventListener('click', this.onDocClick); }

      open(spot) {
        this.closeAll();
        const panel = spot.querySelector('.hotspot__panel');
        spot.classList.add('is-open');
        spot.querySelector('.hotspot__dot').setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        const stage = this.getBoundingClientRect();
        const rect = spot.getBoundingClientRect();
        spot.classList.toggle('hotspot--flip-y', rect.top - stage.top > stage.height * 0.6);
        spot.classList.toggle('hotspot--flip-left', rect.left - stage.left > stage.width * 0.75);
        spot.classList.toggle('hotspot--flip-right', rect.left - stage.left < stage.width * 0.25);
      }

      close(spot) {
        spot.classList.remove('is-open');
        spot.querySelector('.hotspot__dot').setAttribute('aria-expanded', 'false');
        spot.querySelector('.hotspot__panel').hidden = true;
      }

      closeAll() { this.spots.forEach((s) => this.close(s)); }
    }

    customElements.define('mk-hotspots', MkHotspots);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (() => {
    const init = () => {
      if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
      document.querySelectorAll('[data-address-country]').forEach((select) => {
        if (select.dataset.cpsReady) return;
        select.dataset.cpsReady = 'true';
        new window.Shopify.CountryProvinceSelector(select.id, select.dataset.provinceId, {
          hideElement: select.dataset.provinceContainer
        });
      });
    };
    // shopify_common.js is deferred in the section body; wait for it on window load.
    if (document.readyState === 'complete') init();
    else window.addEventListener('load', init);

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[data-confirm]');
      if (form && !window.confirm(form.dataset.confirm)) event.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-copy-link]');
      if (!button || !navigator.clipboard) return;
      navigator.clipboard.writeText(button.dataset.copyLink).then(() => {
        button.classList.add('is-copied');
        button.setAttribute('aria-label', button.dataset.copiedLabel);
        setTimeout(() => button.classList.remove('is-copied'), 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-recover-toggle]');
      if (!toggle) return;
      const auth = toggle.closest('.auth');
      if (!auth) return;
      event.preventDefault();
      const on = toggle.dataset.recoverToggle === 'on';
      auth.classList.toggle('is-recover', on);
      if (window.location.hash === '#recover' && !on) history.replaceState(null, '', window.location.pathname);
      const focusTarget = auth.querySelector(on ? '#RecoverEmail' : '#CustomerEmail');
      if (focusTarget) focusTarget.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('promo-banner')) return;
    class PromoBanner extends HTMLElement {
      connectedCallback() {
        const end = Date.parse(this.dataset.ends);
        const timer = this.querySelector('[data-timer]');
        if (timer && !Number.isNaN(end)) {
          const parts = { d: timer.querySelector('[data-d]'), h: timer.querySelector('[data-h]'), m: timer.querySelector('[data-m]'), s: timer.querySelector('[data-s]') };
          const pad = (n) => String(n).padStart(2, '0');
          const tick = () => {
            const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
            if (left === 0) { clearInterval(this.interval); this.remove(); return; }
            parts.d.textContent = Math.floor(left / 86400);
            parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
            parts.m.textContent = pad(Math.floor((left % 3600) / 60));
            parts.s.textContent = pad(left % 60);
          };
          tick();
          this.interval = setInterval(tick, 1000);
        }
        const copy = this.querySelector('[data-copy]');
        copy?.addEventListener('click', async () => {
          const status = copy.querySelector('.promo__copied');
          try { await navigator.clipboard.writeText(copy.dataset.copy); status.textContent = 'Copied'; }
          catch { status.textContent = ''; }
          clearTimeout(this.copiedTimer);
          this.copiedTimer = setTimeout(() => { status.textContent = ''; }, 2000);
        });
      }
      disconnectedCallback() { clearInterval(this.interval); }
    }
    customElements.define('promo-banner', PromoBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mk-slideshow')) return;

    class MkSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || this.slides.length < 2) return;

        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.scrollToIndex(parseInt(dot.dataset.dot, 10))));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        });

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduced && !window.Shopify?.designMode) {
          this.speed = parseInt(this.dataset.speed, 10) || 5000;
          ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
          ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.play()));
          this.play();
        }

        this.addEventListener('shopify:block:select', (e) => {
          const index = this.slides.indexOf(e.target);
          if (index > -1) { this.stop(); this.scrollToIndex(index, 'auto'); }
        });
      }

      disconnectedCallback() { this.stop(); }

      get perView() {
        const w = this.slides[0].getBoundingClientRect().width;
        return Math.max(1, Math.round(this.track.clientWidth / (w || 1)));
      }

      get step() {
        return (this.slides[1].offsetLeft - this.slides[0].offsetLeft) || this.track.clientWidth;
      }

      get index() {
        return Math.round(this.track.scrollLeft / this.step);
      }

      scrollToIndex(i, behavior = 'smooth') {
        const clamped = Math.max(0, Math.min(i, this.slides.length - 1));
        const offset = this.slides[clamped].offsetLeft - this.slides[0].offsetLeft;
        this.track.scrollTo({ left: offset, behavior });
      }

      go(direction) {
        const last = this.slides.length - this.perView;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        let target = this.index + direction * this.perView;
        if (direction > 0 && atEnd) target = 0;
        else if (direction < 0 && this.index <= 0) target = last;
        this.scrollToIndex(target);
      }

      update() {
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        const current = atEnd ? this.slides.length - 1 : this.index;
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === current ? 'true' : 'false'));
        if (this.prev && this.next && this.dataset.autoplay !== 'true') {
          this.prev.disabled = this.track.scrollLeft <= 4;
          this.next.disabled = atEnd;
        }
      }

      play() {
        this.stop();
        this.timer = setInterval(() => this.go(1), this.speed);
      }

      stop() { clearInterval(this.timer); }
    }

    customElements.define('mk-slideshow', MkSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mk-stats')) return;

    class MkStats extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.nodes = [...this.querySelectorAll('[data-count]')];
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            this.nodes.forEach((n) => this.animate(n));
          }
        }, { threshold: 0.3 });
        io.observe(this);
      }

      animate(node) {
        const original = node.textContent.trim();
        const match = original.match(/^([^\d]*)([\d.,]+)(.*)$/);
        if (!match) return;
        const [, prefix, numText, rest] = match;
        const decimalSep = /\d\.\d{1,2}$/.test(numText) ? '.' : null;
        const target = parseFloat(decimalSep ? numText.replace(/,/g, '') : numText.replace(/[.,]/g, ''));
        if (!isFinite(target)) return;
        const decimals = decimalSep ? numText.split('.')[1].length : 0;
        const useGrouping = /[.,]\d{3}/.test(numText) && !decimalSep;
        const fmt = new Intl.NumberFormat('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping });
        const duration = 1600;
        const start = performance.now();
        const step = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          node.textContent = prefix + fmt.format(target * eased) + rest;
          if (t < 1) requestAnimationFrame(step);
          else node.textContent = original;
        };
        requestAnimationFrame(step);
      }
    }

    customElements.define('mk-stats', MkStats);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mk-sticky-cta')) return;

    class MkStickyCta extends HTMLElement {
      connectedCallback() {
        this.storageKey = `mk-sticky-cta-dismissed-${this.dataset.key}`;
        try {
          if (sessionStorage.getItem(this.storageKey) && !window.Shopify?.designMode) return;
        } catch (e) { /* storage unavailable */ }
        this.hidden = false;
        this.threshold = parseInt(this.dataset.showAfter, 10) || 0;
        this.onScroll = () => {
          const footer = document.querySelector('.section-footer') || document.querySelector('footer');
          const nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight - 40;
          this.classList.toggle('is-visible', window.scrollY > this.threshold && !nearFooter);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        if (window.Shopify?.designMode) this.classList.add('is-visible');
        this.querySelector('[data-dismiss]')?.addEventListener('click', () => this.dismiss());
      }

      disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }

      dismiss() {
        this.classList.remove('is-visible');
        window.removeEventListener('scroll', this.onScroll);
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (e) { /* ignore */ }
      }
    }

    customElements.define('mk-sticky-cta', MkStickyCta);
  })();

  } catch(e) { console.error(e); }
})();
})();
